import { SchemaDeSerBuilder, type SchemaDeSer } from "./deser"

export class SupportedDigitalAsset {
  symbol = ""
}

export const SUPPORTED_DIGITAL_ASSET_DESER: SchemaDeSer<SupportedDigitalAsset> =
  new SchemaDeSerBuilder(SupportedDigitalAsset).ofString("symbol").toDeSer()

export class SupportedWithdrawalAsset {
  customerAddressAsset = ""
  memoSupported = false
  supportedWithdrawalAssets = []
}

export const SUPPORTED_WITHDRAWAL_ASSET_DESER: SchemaDeSer<SupportedWithdrawalAsset> =
  new SchemaDeSerBuilder(SupportedWithdrawalAsset)
    .ofString("customerAddressAsset")
    .ofBoolean("memoSupported")
    .ofArray(
      "supportedWithdrawalAssets",
      SUPPORTED_DIGITAL_ASSET_DESER,
      SupportedDigitalAsset
    )
    .toDeSer()
